<op-bcf-list
  [showResizer]="true"
  *ngIf="showWorkPackages$ | async"
></op-bcf-list>
